import React from 'react';

import type { GoogleRecaptchaV3ContextValues } from './types';

export const GoogleRecaptchaV3Context =
  React.createContext<GoogleRecaptchaV3ContextValues | undefined>(undefined);

export const useGoogleRecaptchaV3Context = () => {
  const context = React.useContext(GoogleRecaptchaV3Context);

  if (context === undefined) {
    console.error('useGoogleRecaptchaV3Context must be used within a GoogleRecaptchaV3Provider');
  }

  return context;
};
